import styled from 'styled-components'
import color from '../../style/colors'

const logoSize = 120

export const LoginStyle = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(/images/background.jpg);
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  position: relative;
  display: flex;
  justify-content: flex-end;
`

export const LoginPanelStyle = styled.div`
  height: 100%;
  background-color: #fff;
  width: 400px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .container {
    padding: 1rem;

    .logo {
      text-align: center;
    }

    .image {
      width: ${logoSize}px;
      height: ${logoSize}px;
      overflow: hidden;
      border-radius: 8px;
      margin: 0 auto 1rem;

      img {
        width: 100%;
      }
    }

    .title {
      font-size: 1.25rem;
      font-weight: bold;
    }
  }

  .action {
    margin: 2rem 0;
    text-align: center;

    .loading {
      height: 44px;
      text-align: center;

      img {
        max-height: 100%;
      }
    }

    .button {
      width: 100%;
    }

    .forbidden {
      color: ${color.red};
    }

    .forbidden, .list, .chooseMsg {
      margin-bottom: 1rem;
    }

    .list {
      border: 1px solid ${color.lightGrey};
      border-radius: 8px;
      list-style: none;
      padding: 0;
      text-align: left;

      li {
        border-bottom: 1px solid ${color.lightGrey};
        padding: 8px 16px;
        &:nth-last-child(1) {
          border-bottom: 0;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
        }

        .detail {
          color: ${color.grey};
          font-size: 14px;
        }

        a {
          text-decoration: none;
          color: ${color.black};
        }

        &:hover {
          background-color: ${color.whiteHighlight};
        }
      }
    }
  }

  .footer {
    text-align: center;
  }
`


// WEBPACK FOOTER //
// ./src/containers/Auth/style.js